/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionCode } from '../../models/promotion-code';
import { PromotionCodeApiRespModel } from '../../models/promotion-code-api-resp-model';

export interface ApiMasterPromotionCodeEditPost$Params {
      body?: PromotionCode
}

export function apiMasterPromotionCodeEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCodeApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromotionCodeApiRespModel>;
    })
  );
}

apiMasterPromotionCodeEditPost.PATH = '/api/Master/PromotionCode/Edit';
